import { type ReactNode, useEffect, useState } from 'react';

import { bridgeApi, BridgeContext } from '@/api/BridgeApi.ts';

export function BridgeProvider({ children }: { children: ReactNode }) {
	const [timestamp, setTimestamp] = useState(0);

	useEffect(() => {
		const forceRender = () => setTimestamp(Date.now());
		bridgeApi.attachProvider(forceRender);
	}, []);

	return (
		<BridgeContext.Provider value={{ api: bridgeApi, timestamp }}>
			{children}
		</BridgeContext.Provider>
	);
}
